import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import Routing, { SideMenu } from '../../components/reusable/routing'
import { useLatestPathname } from '../../modules'

import Admissions from './Admissions'
import Deaths from './Deaths'
import Discharges from './Discharges'
import Abscondees from './Abscondees'
import Wards from './Wards'
import Dashboard from './Dashboard'

let menu = [
    {
        path: '',
        title: 'Dashboard',
        component: Dashboard
    },
    {
        path: 'admissions',
        title: 'Admissions',
        component: Admissions
    },
    {
        path: 'discharges',
        title: 'Discharges',
        component: Discharges
    },
    {
        path: 'deaths',
        title: 'Deaths',
        component: Deaths
    },
    {
        path: 'abscondees',
        title: 'Abscondees',
        component: Abscondees
    },
    {
        path: 'wards',
        title: 'Wards',
        component: Wards
    }
]

const Inpatient = () => {
    const history = useHistory()
    const pathname = useLatestPathname()

    const { user } = useSelector(state => state.application)

    useEffect(() => {
        const target = `/app/inpatient/${menu[1].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [user])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Inpatient</p>
                <SideMenu namespace="inpatient" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="inpatient" menu={ menu } />
            </div>
        </div>
    )
}

export default Inpatient